import { useState } from 'react'
import { connect } from 'react-redux'
import Modal from 'components/modal/modal'
import { Col, ModalBody, Row } from 'react-bootstrap'
import { InfoButton } from 'components/buttons'
import { deleteUser } from '../../actions'
// @ts-ignore
import { parseErrors } from 'lib/api-utils'
// @ts-ignore
import { errorMessage } from 'lib/flash-message'
// @ts-ignore
import { babylossPath, storePath } from 'lib/urls'
// @ts-ignore
import { numberToCurrency } from 'lib/money'
import TellUsWhyModal from './tell-us-why-modal'
// @ts-ignore
import { track, useTracking, withContextualizedTracking } from 'lib/analytics'
import { SubHeading } from 'components/headings'

export interface DeactivateAccountModalProps {
  deleteUser(): Promise<Response>
  onHide(): void
  userBalance?: number
  show?: boolean
}

interface ConfirmationModalProps {
  deleteUser(): void
  onHide(): void
  userBalance?: number
}

interface StateValues {
  userCredit: {
    balance?: number
  }
}

const DeactivateAccountModal = ({
  deleteUser,
  onHide,
  userBalance,
  show,
}: DeactivateAccountModalProps) => {
  const [deactivated, setDeactivated] = useState(false)
  const tracker = useTracking()

  const trackAccountDeactivationReasonGiven = (reason: string) => {
    tracker.trackEvent({
      // @ts-ignore
      event: track.accountDeactivationReasonGiven,
      deactivationReason: reason,
    })
  }

  const handleDelete = () => {
    deleteUser()
      .then(() => {
        setDeactivated(true)
        tracker.trackEvent({
          // @ts-ignore
          event: track.accountDeactivated,
        })
      })
      .catch((resp: any) => {
        errorMessage(parseErrors(resp)._error)
      })
  }

  const Header = (
    <Row className="bbs">
      <Col xs={12}>
        <SubHeading className="h3 bvn ptm">Account Deactivated</SubHeading>
        <p>
          You no longer have access to your registry or Babylist account and you
          will no longer receive messages from us.
        </p>
      </Col>
    </Row>
  )

  const onSubmit = (reason: string) => {
    if (reason) {
      trackAccountDeactivationReasonGiven(reason)
      reason === 'Experienced a Loss'
        ? (window.location.href = babylossPath)
        : (window.location.href = '/')
    }
  }

  if (show) {
    if (deactivated) {
      return (
        <TellUsWhyModal
          Header={Header}
          subHeadingText="Why did you deactivate?"
          onSubmit={onSubmit}
        />
      )
    }
    return (
      <ConfirmationModal
        onHide={onHide}
        userBalance={userBalance}
        deleteUser={handleDelete}
      />
    )
  }
  return null
}

const ConfirmationModal = ({
  onHide,
  deleteUser,
  userBalance,
}: ConfirmationModalProps) => {
  const title = userBalance ? 'Wait a minute!' : 'Are you sure?'

  return (
    <Modal show onHide={onHide} title={title}>
      <ModalBody>
        <Row>
          <Col xs={12}>
            {userBalance ? (
              <p>
                You have a gift card balance of{' '}
                <strong>{numberToCurrency(userBalance)}</strong>. If you
                deactivate your account,{' '}
                <strong>you will no longer have access</strong> to your gift
                card balance, registry or Babylist account.
              </p>
            ) : (
              <p>
                If you deactivate your account,{' '}
                <strong>you will no longer have access</strong> to your registry
                or your Babylist account.
              </p>
            )}

            <p>
              <strong>Are you sure you want to deactivate your account?</strong>
            </p>
          </Col>
        </Row>

        <Row className="mtl">
          <Col sm={6}>
            {userBalance ? (
              <InfoButton empty href={storePath} className="full-width">
                No, Go to Babylist Shop
              </InfoButton>
            ) : (
              <InfoButton empty onClick={onHide} className="full-width">
                No, Go Back
              </InfoButton>
            )}
          </Col>

          <Col sm={6}>
            <InfoButton onClick={deleteUser} className="mbm full-width">
              Yes, Deactivate
            </InfoButton>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state: StateValues) => ({
  userBalance: state.userCredit?.balance,
})

const mapDispatchToProps = (dispatch: any) => ({
  deleteUser: (data: any) => dispatch(deleteUser(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContextualizedTracking()(DeactivateAccountModal))
